export { default } from '@fhs/routing/src/routes/+not-found';
